<script>
import { changePassword } from '../../services/userService'

const defaultErrors = {
  oldPassword: null,
  newPassword: null,
  confirmPassword: null
}

export default {
  name: 'AccountForm',
  props: {
    userForm: { type: Object, required: true },
    errors: { type: Object, required: true }
  }
}
</script>

<template>
  <div class="account-form">
    <b-field grouped>
      <b-field
        label="First name"
        :type="{ 'is-danger': !!errors.firstName }"
        :message="errors.firstName"
        expanded
      >
        <b-input
          v-model="userForm.firstName"
          type="text"
          placeholder="First name"
          required
        />
      </b-field>
      <b-field
        label="Last name"
        :type="{ 'is-danger': !!errors.lastName }"
        :message="errors.lastName"
        expanded
      >
        <b-input
          v-model="userForm.lastName"
          type="text"
          placeholder="Last name"
          required
        />
      </b-field>
    </b-field>

    <b-field
      label="Email"
      :type="{ 'is-danger': !!errors.email }"
      :message="errors.email"
    >
      <b-input
        v-model="userForm.email"
        type="email"
        placeholder="Email"
        required
      />
    </b-field>

    <b-field
      label="Password"
      :type="{ 'is-danger': !!errors.password }"
      :message="errors.password || 'At least 6 characters.'"
    >
      <b-input
        v-model="userForm.password"
        type="password"
        placeholder="Password"
        password-reveal
        required
      />
    </b-field>
  </div>
</template>

<style lang="sass">
.change-password-form
  margin-bottom: 24px
  h2.title
    margin-bottom: 16px
  .modal-card-foot
    justify-content: flex-end
</style>
